/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBulkPolicyTrigger extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBulkPolicyTrigger");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBulkPolicyTrigger.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBulkPolicyTrigger>): BackgroundJobPayloadForBulkPolicyTrigger {
        let obj = Object.assign(new BackgroundJobPayloadForBulkPolicyTrigger(), model);
        BackgroundJobPayloadForBulkPolicyTrigger.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBulkPolicyTrigger>): BackgroundJobPayloadForBulkPolicyTrigger {
        if (!model) return null;
        return BackgroundJobPayloadForBulkPolicyTrigger.newInstance(<BackgroundJobPayloadForBulkPolicyTrigger> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBulkPolicyTrigger) {
        if (!obj) return;

        models.BackgroundJobPayloadForBulkPolicyTrigger.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBulkPolicyTrigger): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBulkPolicyTrigger.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.policy_info) {
            for (let val of this.policy_info) {
                models.PolicyTriggerInfo.fixupPrototype(val);
            }
        }
    }

    execution_reference: string;

    execution_group: string;

    master_account_id: string;

    tenant_id: string;

    username: string;

    service_accounts: Array<string>;

    policy_info: Array<models.PolicyTriggerInfo>;

    applicable_resources: Array<string>;

}
